import React from 'react';
import './src/styles/fontImports.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './src/app/App';

const CHUNK_RECOVERY_KEY = 'moogong_chunk_recovery_reloaded';

const isChunkLoadError = (reason: unknown) => {
  const message =
    reason instanceof Error
      ? `${reason.name} ${reason.message}`
      : typeof reason === 'string'
      ? reason
      : String((reason as { message?: unknown })?.message ?? '');

  return /ChunkLoadError|Loading chunk \d+ failed|Loading CSS chunk \d+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(
    message,
  );
};

const recoverFromChunkLoadError = async (reason: unknown) => {
  if (!isChunkLoadError(reason)) return;
  if (sessionStorage.getItem(CHUNK_RECOVERY_KEY) === '1') return;

  sessionStorage.setItem(CHUNK_RECOVERY_KEY, '1');

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
  }

  window.location.reload();
};

window.addEventListener('error', (event) => {
  recoverFromChunkLoadError(event.error || event.message).catch((error) => {
    console.error('[ChunkRecovery] 복구 실패:', error);
  });
});

window.addEventListener('unhandledrejection', (event) => {
  recoverFromChunkLoadError(event.reason).catch((error) => {
    console.error('[ChunkRecovery] 복구 실패:', error);
  });
});

window.setTimeout(() => {
  sessionStorage.removeItem(CHUNK_RECOVERY_KEY);
}, 5000);

render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.querySelector('#root'),
);

// =============================================
//   PWA 설치 프롬프트 전역 캡처
//   React lazy 컴포넌트보다 먼저 이벤트를 잡아두기 위해 entry point에서 처리
// =============================================
(window as any).__pwaInstallPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  (window as any).__pwaInstallPrompt = e;
  window.dispatchEvent(new Event('pwa-install-ready'));
});

window.addEventListener('appinstalled', () => {
  (window as any).__pwaInstallPrompt = null;
  window.dispatchEvent(new Event('pwa-app-installed'));
});

// =============================================
//   PWA Service Worker 등록
// =============================================
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[SW] 등록 성공:', registration.scope);

        // 업데이트 감지
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated') {
                console.log('[SW] 새 버전 활성화됨');
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('[SW] 등록 실패:', error);
      });
  });
}
